module.exports = __webpack_public_path__ + "static/media/Buvidal Weekly CMI.4f92d389.pdf";